export default __webpack_public_path__ + "static/media/fb.f8b06d44.svg";